import { SettingsRoutes } from 'pages/settings/route/type'
import { PersonalRoutes } from './type'

const root = `${SettingsRoutes.root}/${PersonalRoutes.root}`
const profile = `${root}/${PersonalRoutes.settings}/${PersonalRoutes.profile}`
const security = `${root}/${PersonalRoutes.settings}/${PersonalRoutes.security}`
const voicemailDrop = `${root}/${PersonalRoutes.settings}/${PersonalRoutes.voicemailDrop}`
const authorizedApps = `${root}/${PersonalRoutes.authorizedApps}`
const personalFull = `${root}/${PersonalRoutes.settings}`

export const PersonalPath = {
  root: root,
  profile: profile,
  security: security,
  voicemailDrop: voicemailDrop,
  authorizedApps: authorizedApps,
  personalFull: personalFull,
}
